import React, {FC} from "react";
import {PageHeader} from "../../../../lib/src/components/content/PageHeader";
import {SectionHeader} from "../../../../lib/src/components/content/SectionHeader";
import {Button} from "../../../../lib/src/components/form/Button";
import { faTrash} from "@fortawesome/free-solid-svg-icons";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {Flow} from "../../../../lib/src/api/repositories/flows-repository";
import {ContentContainer} from "../../../../lib/src/components/content/ContentContainer";
import {useParams} from "react-router-dom";
import {Loading} from "../../../../lib/src/components/Loading";
import {useEmployeesData} from "../../resources/EmployeeContext";
import {FlowScheduleIndexTable} from "../../components/flowbuilder/FlowScheduleIndexTable";
import {FlowEditor} from "../../components/flowbuilder/FlowEditor";
import {FlowDetailsForm} from "../../components/flowbuilder/FlowDetailsForm";
import {Callout} from "@jane/lib/src/components/content/Callout";
import {DeletePlannedFlowSchedulesModal} from "../../modals/DeletePlannedFlowSchedulesModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const FlowDetailsPage: FC<{}> = () => {
  const {flowId} = useParams()
  if (! flowId) {
    return <div>Deze pagina bestaat niet.</div>
  }
  return <FlowDetailsPageContent flowId={flowId} />
}

const FlowDetailsPageContent: FC<{flowId: string}> = ({flowId}) => {
  const {flows} = useApiCall(config)
  const flowResource = useApiEndpoint(() => flows.getFlow(flowId))
  const flowFilesResource = useApiEndpoint(() => flows.listFlowFiles())
  const { employees, isLoading, error } = useEmployeesData()


  if (flowResource?.isLoading || flowFilesResource?.isLoading) {
    return <ContentContainer size={'lg'}>
      <Loading loading={true}><></></Loading>
    </ContentContainer>
  }


  return <ContentContainer size={'lg'}>
    <PageHeader>{ flowResource.resource?.name }</PageHeader>

    <section className={'my-12'}>
      {flowResource?.resource && <FlowDetailsForm isLoading={flowResource?.isLoading} flow={flowResource?.resource} reload={() => flowResource.reload()}/>}
    </section>

    <section className={'my-12'}>
      <SectionHeader>Flow</SectionHeader>
      {flowResource?.resource && <FlowEditor isLoading={flowResource?.isLoading} flow={flowResource?.resource} reload={() => flowResource.reload()}/>}
    </section>

    <section className={'my-12'}>
      <SectionHeader>Planning & Geschiedenis</SectionHeader>
      {flowResource.resource && !flowResource.resource?.enabled && flowResource.resource?.schedules?.some((fs) => fs.finished_at === null) && <InactivePlannedFlowsCallout flow={flowResource.resource} reload={() => flowResource.reload()} />}
      <FlowScheduleIndexTable isLoading={flowResource?.isLoading || isLoading} schedules={flowResource.resource?.schedules ?? []} employees={employees} />
    </section>
  </ContentContainer>
}

const InactivePlannedFlowsCallout: FC<{ flow: Flow, reload: () => void }> = (props) => {
  const deleteModal = useModal({title: "Geplande flows verwijderen", body: <DeletePlannedFlowSchedulesModal flow={props.flow} onFinished={() => props.reload()} />, size: "lg"})

  return <Callout color={'primary'}>
    <div className={'flex flex-col gap-2'}>
      <div>Let op! Deze flow is niet actief!</div>
      <div>Er staan nog enkele taken op gepland.</div>
      <div>
        <Button type={"secondary"} size={'xs'} icon={faTrash} text={'Verwijderen'} onClick={() => deleteModal.open()} />
      </div>
    </div>
  </Callout>
}